<template>
  <div class="record-page" v-loading="infoLoading">
    <div class="sec-hd">
      <h2 class="title">跟进记录</h2>
      <div class="btn-group">
        <el-button type="primary" size="medium" @click="showDialog=true;form.description = ''">写跟进</el-button>
      </div>
    </div>
    <ul class="record-list">
      <li class="" v-for="(item,index) in recordList" :key="index">
        <div class="dl">
          <div class="dt">
            <div class="name">{{item.userName}}</div>
            <div class="time">{{item.updateTime.substr(0,16)}}</div>
          </div>
          <p class="desc">{{item.description}}</p>
          <p class="next-time" v-if="item.nextTime">下次跟进时间：{{item.nextTime.substr(0,10)}}</p>
        </div>
      </li>
    </ul>
    <el-dialog
      title="新增跟进"
      :visible.sync="showDialog"
      width="600px"
      center>
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="下次跟进日期" prop="followTime">
          <el-date-picker
            type="date"
            v-model="form.nextTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="跟进描述" prop="description" class="word-limit">
          <el-input type="textarea" v-model.trim="form.description" resize="none" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  custFollow,
  custFollowAdd
} from '@/service/customerInformation.js';
import {getStorageUserRoleId} from '@/utils/store'
export default {
  data(){
    return{
      infoLoading: false,
      showDialog:false,
      recordList:[],
      form:{
        nextTime:'',
        description:'',
      },
      rules:{
        // followTime:[{required:true,message: '请选择日期', trigger: 'change'}],
        description:[{required:true,message: '请输入跟进描述', trigger: 'blur'}]
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(){
      let custId=Number(this.$route.query.custId);
      this.infoLoading = true
      custFollow({
        custId
      }).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          this.recordList=r.Data.datas ||[];
        }
      })
    },
    submit(){
      this.$refs.form.validate(valid=>{
        if(valid){
          let custId=Number(this.$route.query.custId);
          let params={
            description:this.form.description,
            nextTime:this.form.nextTime?this.form.nextTime+' 00:00:00':null,
            custId:custId,
            userId:getStorageUserRoleId(),
          }
          custFollowAdd(params).then(r=>{
            if(r.Result==1){
              this.$message.success('添加成功');
              this.showDialog=false;
              this.loadData();
            }else{
              this.$message.info(r.Message);
            }
          })
        }
      })
      
    }
  },
}
</script>
<style lang="scss">
.record-page{
  .sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
    .btn-group{
      float: right;
    }
	}
  .record-list{
    border: 1px solid #e5e5e5;
    background-color: #fff;
    padding: 20px 30px;
    >li{
      margin-bottom: 20px;
    }
    .date{
      font-size: 20px;
      color: #333;
      font-family: arial;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .dl{
      padding: 20px 22px;
      background-color: #f9f9f9;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
    }
    .dt{
      overflow: hidden;
      margin-bottom: 20px;
    }
    .name{
      font-size: 20px;
      color: #333;
      font-weight: bold;
      line-height: 30px;
      float: left;
    }
    .time{
      font-size: 16px;
      color: #333;
      line-height: 30px;
      font-family: arial;
      float: right;
    }
    .desc{
      font-size: 14px;
      color: #666;
      line-height: 24px;
      word-break: break-all;
    }
    .next-time{
      font-size: 14px;
      color: #666;
      line-height: 24px;
      margin-top: 10px;
    }
  }
}
.word-limit {
  .el-input__count {
    line-height: 22px;
  }
}
</style>